import { render, staticRenderFns } from "./FAQList.vue?vue&type=template&id=505e08fc&scoped=true"
import script from "./FAQList.vue?vue&type=script&lang=js"
export * from "./FAQList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e08fc",
  null
  
)

export default component.exports